'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
Entry.DragInstance = /*#__PURE__*/(0, _createClass2["default"])(function DragInstance(model) {
  (0, _classCallCheck2["default"])(this, DragInstance);
  this.schema = {
    type: Entry.STATIC.DRAG_INSTANCE,
    startX: 0,
    startY: 0,
    offsetX: 0,
    offsetY: 0,
    absX: 0,
    absY: 0,
    prev: null,
    height: 0,
    mode: 0,
    isNew: false
  };
  Entry.Model(this);
  this.set(model);
});